<template>
    <div class="container mx-auto p-6">
        <section class="my-8">
            <h1 class="text-4xl font-bold text-center font-orbitron mb-4">Labs</h1>
            <p class="mx-auto max-w-2xl text-center text-lg font-roboto text-gray-700">
                Our own projects. This is where we try techniques before they show up in client work — and where
                some of them turn into products.
            </p>
            <p v-if="investmentCount" class="mx-auto mt-4 max-w-2xl text-center font-roboto text-gray-700">
                {{ investmentCount }} of these are raising.
                <router-link :to="{ path: '/contact', query: { service: 'Investment' } }"
                    class="text-blue-600 hover:text-blue-800 underline">Talk to us about investing</router-link>.
            </p>
        </section>

        <div v-if="labs.length" class="mb-8">
            <input type="search" placeholder="Search labs..." class="p-2 border border-gray-300 rounded"
                v-model="searchTerm" aria-label="Search labs">
        </div>

        <p v-if="loading" class="py-12 text-center font-roboto text-gray-600">Loading projects…</p>

        <div v-else-if="filteredlabs.length" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <article class="flex flex-col rounded-lg border border-gray-200 bg-white overflow-hidden shadow-lg"
                v-for="lab in filteredlabs" :key="lab.permalink">
                <router-link :to="'/labs/' + lab.permalink" class="block hover:no-underline">
                    <img v-if="lab.image" v-lazy="lab.image" :alt="lab.title" class="w-full aspect-video object-cover">
                    <!-- Not every project has a photograph; keep the grid even. -->
                    <div v-else
                        class="flex aspect-video items-center justify-center bg-gray-900 px-4 text-center font-orbitron text-xl text-white">
                        {{ lab.title }}
                    </div>
                </router-link>
                <div class="flex flex-grow flex-col p-4">
                    <span v-if="lab.seeking_investment"
                        class="mb-2 self-start rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-900">
                        Seeking investment
                    </span>
                    <router-link :to="'/labs/' + lab.permalink" class="hover:no-underline">
                        <h2 class="text-lg font-bold mb-2">{{ lab.title }}</h2>
                    </router-link>
                    <p class="flex-grow text-gray-700 text-base mb-4">{{ lab.short_summary }}</p>
                    <router-link :to="'/labs/' + lab.permalink"
                        class="self-start text-blue-600 hover:text-blue-800 underline">Learn more</router-link>
                </div>
            </article>
        </div>

        <div v-else class="py-12 text-center font-roboto">
            <p class="text-lg text-gray-700">
                {{ searchTerm ? 'No projects match that search.' : 'No projects are published right now.' }}
            </p>
            <router-link v-if="!searchTerm" to="/contact" class="btn-primary mt-6">Start a project</router-link>
        </div>

        <section v-if="labs.length" class="my-12 border-t border-gray-200 pt-8 text-center">
            <p class="text-lg font-roboto text-gray-700">
                Want something like this built for your own problem?
            </p>
            <router-link to="/contact" class="btn-primary mt-6">Start a project</router-link>
        </section>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LabsComponent',
    data() {
        return {
            searchTerm: '',
            labs: [],
            loading: true,
        };
    },
    computed: {
        filteredlabs() {
            const term = this.searchTerm.toLowerCase();
            return this.labs.filter(lab => (lab.title || '').toLowerCase().includes(term));
        },
        investmentCount() {
            return this.labs.filter(lab => lab.seeking_investment).length;
        },
    },
    methods: {
        fetchlabsData() {
            axios.get('/api/labs')
                .then(response => {
                    this.labs = Array.isArray(response.data) ? response.data : [];
                })
                .catch(() => {
                    this.labs = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.fetchlabsData();
    },
};
</script>
